export enum Nationalities {
  angolan,
  botswanan,
  mozambican,
  namibian,
  nigerian,
  southAfrican,
  ugandan,
  zimbabwean,
  zambian,
  other
}
